import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { MouseEvent, useCallback, useContext } from "react";
import { AppDownload, LoginButton, Logo, RegisterButton, SlotGames } from "src/assets";
import { FloatingBanner } from "src/main/components";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">WOW69</VisuallyHidden>

      <Stack
        alignItems="center"
        justifyContent="center"
      >
        <img
          alt="logo"
          src={Logo}
          height={164}
          style={{ marginTop: "-20px", marginBottom: "-12px" }}
        />

        <Box sx={{ zIndex: 1000, display: "flex", alignItems: "center" }}>
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="login button"
              src={LoginButton}
              height={46}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="register button"
              src={RegisterButton}
              height={61}
              style={{ marginTop: -3 }}
            />
          </a>
        </Box>
      </Stack>

      <img
        alt="slot games"
        src={SlotGames}
        width={350}
        style={{ marginTop: "-88px" }}
      />

      <img
        src={AppDownload}
        alt="app download"
        width={210}
        style={{ marginTop: "-16px" }}
      />

      <FloatingBanner />
    </Box>
  );
};

const styles = createStyles({
  root: {
    pt: "20px",
    pb: "20px",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
  },
});

export default LandingPage;
